// extracted by mini-css-extract-plugin
export var CtaSectionsContainer = "CallToActionSections-module--CtaSectionsContainer--87870";
export var buttonWrapper = "CallToActionSections-module--buttonWrapper--04274";
export var buttonWrapperCol = "CallToActionSections-module--buttonWrapperCol--9e90d";
export var buttonWrapperCols = "CallToActionSections-module--buttonWrapperCols--84925";
export var ctaSection = "CallToActionSections-module--ctaSection--b4024";
export var sectionFull = "CallToActionSections-module--sectionFull--124ff";
export var sectionHalf = "CallToActionSections-module--sectionHalf--62ea3";
export var sectionTitle = "CallToActionSections-module--sectionTitle--913d5";